import { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import { colours } from "@/utils";
import { Device } from "@/utils/device";

const discoverCopy = [
  "Investing in your personal and professional development is a strategic move. You will boost not just your performance, but your job satisfaction and earning potential as well.",
  <br key="1" />,
  <br key="2" />,
  "Join us now, the ROI is undeniable.",
];

const links = [
  {
    id: "accelerate",
    text: "AllBright Accelerate",
  },
  {
    id: "elevate",
    text: "AllBright Elevate",
  },
  {
    id: "elevate-board",
    text: "Elevate to the Board",
  },
];

const handleClick = (e, id) => {
  e.preventDefault();
  const headerHeight = 80;
  const targetElement = document.getElementById(id);

  if (targetElement) {
    window.scrollTo({
      top: targetElement.offsetTop - headerHeight,
      behavior: "smooth",
    });
  }
};

const FulfilYourAmbitionContent: FunctionComponent = () => {
  return (
    <S.Section>
      <S.TextContent>
        <S.Title>
          <i>Fulfil</i> your <br />
          ambition
          <br />
          <S.BoldWrap>with our programmes</S.BoldWrap>
        </S.Title>
        <S.Copy>{discoverCopy}</S.Copy>
        {links.map((link) => (
          <S.LinkText key={link.text} onClick={(e) => handleClick(e, link.id)}>
            {link.text}
          </S.LinkText>
        ))}
      </S.TextContent>
      <S.ImageContainer>
        <Image
          src="/images/marketing/woman-blue-background.png"
          alt=""
          layout="fill"
          objectFit="cover"
          objectPosition="right"
        />
      </S.ImageContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  background: linear-gradient(180deg, #757eb7 0%, #474c81 100%);
  color: ${colours.shell};
  display: flex;
  flex-direction: column;
  align-content: center;

  @media (min-width: 620px) {
    background-color: #53578a;
    background-image: url("/images/marketing/woman-blue-background.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
  }
`;

S.TextContent = styled.div`
  padding: 3rem 10%;

  @media (min-width: 620px) {
    width: 50vw;
  }

  @media (min-width: ${Device.tablet}) {
    padding: 5rem 10%;
    width: 50vw;
  }

  @media (min-width: ${Device.desktop}) {
    padding-top: 6rem;
    width: 60vw;
  }
`;

S.Title = styled.h2`
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 6rem;
  font-weight: 100;
  line-height: 5.5rem;

  @media (min-width: ${Device.tablet}) {
    font-size: 7rem;
    line-height: 6rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 8rem;
    line-height: 6.5rem;
  }
`;

S.BoldWrap = styled.span`
  font-family:
    HK Grotesk,
    sans-serif;
  font-weight: 800;
  letter-spacing: -2px;

  @media (min-width: ${Device.tablet}) {
    font-size: 6rem;
    line-height: 0rem;
  }
`;

S.Copy = styled.p`
  padding: 3rem 0;

  @media (min-width: ${Device.tablet}) {
    padding: 4rem 0;
    font-size: 1.8rem;
  }

  @media (min-width: ${Device.desktop}) {
    padding: 5rem 0;
    font-size: 2rem;
  }
`;

S.LinkText = styled.a`
  display: block;
  text-decoration: underline;
  padding-bottom: 1.5rem;
  cursor: pointer;

  @media (min-width: ${Device.tablet}) {
    font-size: 1.8rem;
    padding-bottom: 2rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 2rem;
    padding-bottom: 2.5rem;
  }
`;

S.ImageContainer = styled.div`
  position: relative;
  height: 35rem;
  width: 100%;

  @media (min-width: ${Device.mobile}) {
    height: 45rem;
  }

  @media (min-width: 620px) {
    display: none;
  }
`;

export default FulfilYourAmbitionContent;
